import { EmailArtifactLocation } from '@amazon-connect/email';
import config from '../config';

interface AttachmentResponse {
  url: string;
  fileName: string;
  contentType: string;
}

export const fetchAttachment = async (
  location: EmailArtifactLocation,
  contactId: string
): Promise<AttachmentResponse> => {
  const apiUrl = config.emailApiUrl;

  if (!apiUrl) {
    throw new Error('Email API Url is not configured');
  }

  const params = new URLSearchParams({
    fileId: location.fileId,
    associatedResourceArn: location.associatedResourceArn,
    contactId
  });

  const response = await fetch(`${apiUrl}/attachment?${params.toString()}`, {
    method: 'GET'
  });

  if (!response.ok) throw new Error(`API responded with status ${response.status}`);

  const json = (await response.json()) as {
    meta: { version: string };
    data: AttachmentResponse;
  };

  return json.data;
};
